import Card1Horizontal from "ui/components/Cards/Card1Horizontal";
import colors from "core/resources/theme/colors";
import { FaFileInvoice } from "react-icons/fa";
import { SimpleGrid } from "@chakra-ui/layout";

interface DashboardArrecadacoesProps {
  aProcessar?: number;
  normais?: number;
  extras?: number;
  loading?: boolean;
}

function DashboardArrecadacoes({
  aProcessar = 0,
  normais = 0,
  extras = 0,
  loading,
}: DashboardArrecadacoesProps) {
  return (
    <SimpleGrid
      columns={{ sm: 1, md: 1, lg: 3, xl: 3 }}
      gap="16px"
      mb="32px"
      mt="40px"
    >
      <Card1Horizontal
        icon={<FaFileInvoice fontSize="24px" color={colors.orange} />}
        color={colors.orange}
        bg={colors.orange50}
        description="A processar"
        onClick={() => {}}
        title={`${aProcessar}`}
        loading={loading}
      />

      <Card1Horizontal
        icon={<FaFileInvoice fontSize="24px" color={colors.green} />}
        color={colors.green}
        bg={colors.green100}
        description="Boletos Normais"
        onClick={() => {}}
        title={`${normais}`}
        loading={loading}
      />

      <Card1Horizontal
        icon={<FaFileInvoice fontSize="24px" color={colors.blue} />}
        color={colors.blue}
        bg={colors.blue100}
        description="Boletos extras"
        onClick={() => {}}
        title={`${extras}`}
        loading={loading}
      />
    </SimpleGrid>
  );
}

export default DashboardArrecadacoes;
